import React, { useEffect} from 'react';
import '../../App.css';
import Footer from '../Footer';
import HomeGallery from '../HomeGallery';


function PortfolioMotorsport() {
    useEffect(() => {
            const timer = setTimeout(() => {
                window.scrollTo({ top: window.innerHeight * 0.75, behavior: 'smooth' });
                }, 50);
    
            return () => clearTimeout(timer);
    }, []);
        
    return (
    <>
        <h1 className='portfolio-hero'>Portfolio</h1>

        <h1 className='text'>Motorsports</h1>

        <HomeGallery images={[
            '/images/img-motorsport-5.jpg','/images/img-motorsport-6.jpg','/images/img-motorsport-7.jpg','/images/img-motorsport-8.jpg','/images/img-motorsport-33.jpg','/images/img-motorsport-15.jpg','/images/img-motorsport-10.jpg','/images/img-motorsport-12.jpg','/images/img-motorsport-24.jpg','/images/img-motorsport-25.jpg','/images/img-motorsport-17.jpg','/images/img-motorsport-18.jpg','/images/img-motorsport-22.jpg','/images/img-motorsport-23.jpg','/images/img-motorsport-30.jpg','/images/img-motorsport-11.jpg','/images/img-motorsport-16.jpg','/images/img-motorsport-21.jpg','/images/img-motorsport-19.jpg','/images/img-motorsport-20.jpg','/images/img-motorsport-3.jpg','/images/img-motorsport-34.jpg','/images/img-motorsport-27.jpg','/images/img-motorsport-36.jpg','/images/img-motorsport-13.jpg','/images/img-motorsport-31.jpg','/images/img-motorsport-29.jpg','/images/img-motorsport-9.jpg','/images/img-motorsport-32.jpg','/images/img-motorsport-14.jpg','/images/img-motorsport-35.jpg','/images/img-motorsport-26.jpg'
        ]} />

        <Footer />
    </>
  )
}

export default PortfolioMotorsport
